import { EventEmitter } from '@angular/core';

export class ErrorHandler {

    public ee: EventEmitter<Error> = new EventEmitter();
    private static _instance:ErrorHandler = new ErrorHandler();

    constructor() {
        if(ErrorHandler._instance){
            throw new Error("Error: Instantiation failed: Use ErrorHandler.getInstance() instead of new.");
        }

        ErrorHandler._instance = this;
    }

    static getInstance() {
        return this._instance;
    }

    emit (err: Error) {
        this.ee.emit(err);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/ErrorHandler.ts